package com.narbase.letsgo.web.views.support

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.support.ExtendedSupportItemDto
import com.narbase.letsgo.web.dto.support.SupportCategoryDto
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.support.GetSupportListEndpoint
import com.narbase.letsgo.web.routing.domain.admin.support.UpsertSupportCategoryEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class SupportManagementViewModel {

    val uiState = Observable<BasicUiState>()
    val getUiState = Observable<BasicUiState>()
    val upsertUiState = Observable<BasicUiState>()
    var supportItemList: List<ExtendedSupportItemDto> = listOf()


    var pageNo = 0
    var pageSize = 20
    var total = 0
    fun getSupportItems() {
        basicNetworkCall(getUiState) {
            val dto = GetSupportListEndpoint.Request(null, pageNo, pageSize, null)
            val response = GetSupportListEndpoint.remoteProcess(dto).data
            supportItemList = response.list.toList()
            total = response.total
        }
    }

    fun upsertSupportCategory(supportCategory: SupportCategoryDto) {
        basicNetworkCall(upsertUiState) {
            val dto = UpsertSupportCategoryEndpoint.Request(supportCategory)
            UpsertSupportCategoryEndpoint.remoteProcess(dto)
        }

    }

    fun searchFor(term: String) {
        pageNo = 0
        uiState.value = BasicUiState.Loaded
        getSupportItems()
    }

    fun getNextPage() {
        pageNo++
        getSupportItems()
    }

    fun getPreviousPage() {
        pageNo--
        getSupportItems()
    }
}